import { ReactNode } from 'react';
import { Stack } from '@mui/material';

export type PrivateLayoutMobileProps = {
  children?: ReactNode;
};

export function PrivateLayoutMobile({ children }: PrivateLayoutMobileProps) {
  return (
    <Stack className="h-screen w-screen overflow-hidden bg-gray-950">
      {/* <MainAppHeader /> */}

      <Stack direction="row" className="h-[calc(100%-62px)] w-full">
        {/* <MainAppSidebar /> */}

        <div className="relative h-full flex-1 overflow-auto">{children}</div>
      </Stack>
    </Stack>
  );
}

export default PrivateLayoutMobile;
